import React from 'react';

export default function btnBlock({ children, ...restProps }) {
  return (
    <button {...restProps} className="hover:border-2 hover:border-primary-dark hover:border-solid text-center bg-primary-dark md:w-[300px] xl:w-354 h-14 text-primary-white">{children}</button>
  );
}
 